import { useIsPeriodicReview } from '@/features/periodic-review/context';
import { useProfileIdentity, useProfileIdentityMutation } from '@/hooks/queries/use-profile-identity';
import { useProfilePeriodicReviewIdentity, useProfilePeriodicReviewIdentityMutation } from '@/hooks/queries/use-profile-periodic-review';

// These work on the draft inside a periodic review and on the live record everywhere else

export const useIdentity = () => {
  const isPeriodicReview = useIsPeriodicReview();
  const liveIdentity = useProfileIdentity(!isPeriodicReview);
  const { data: draft, ...draftQuery } = useProfilePeriodicReviewIdentity(isPeriodicReview);

  return isPeriodicReview ? { ...draftQuery, data: draft?.identity, isComplete: draft?.isComplete } : liveIdentity;
};

export const useIdentityMutation = () => {
  const isPeriodicReview = useIsPeriodicReview();
  const liveMutation = useProfileIdentityMutation();
  const draftMutation = useProfilePeriodicReviewIdentityMutation();

  return isPeriodicReview ? draftMutation : liveMutation;
};
